import React from 'react';
import { Checkbox, Button, Modal } from 'antd';

import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

import './calendar-checkbox.less';

const CalendarCheckbox = (props) => {
  const { rootContainer, item, canChange, onEdit, onDelete } = props;

  const showConfirmDelete = (id, name) => {
    confirm({
      getContainer: rootContainer,
      title: `Are you sure you want to delete '${name}' category?`,
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        onDelete(id);
      },
    });
  };

  return (
    <div className="calendar-ckeckbox-wrapper " key={'checkbox-wrapper-' + item.id}>
      <Checkbox key={item.id} name={item.categoryName} value={item.id} defaultChecked={item.checked} title={item.title}>
        {item.categoryName}
      </Checkbox>
      <div className="calendar-checkbox-settings">
        {canChange && (
          <div className="calendar-checkbox-options">
            <Button
              type="default"
              title="Delete"
              className="calendar-category-btn"
              icon={<DeleteOutlined className="calendar-scheduler-icon-btn" />}
              ghost
              size="small"
              onClick={($event) => showConfirmDelete(item.id, item.categoryName)}
            />
            <Button
              type="default"
              title="Edit"
              className="calendar-category-btn"
              icon={<EditOutlined className="calendar-scheduler-icon-btn" />}
              ghost
              size="small"
              onClick={($event) => onEdit(item)}
            />
          </div>
        )}
        {item.color ? <span className="calendar-checkbox-colormarker " style={item.color ? { backgroundColor: item.color } : {}}></span> : null}
      </div>
    </div>
  );
};

export default CalendarCheckbox;
